import PxoOciosidadeTable             from './PxoOciosidadeTable'
import api                          from '../../../../services/api'

import { useEffect, useState }      from 'react'
import { usePxoPage }               from "../../../../contexts/PxoPageContext"

import PxoLoadingTable                    from '../PxoLoadingTable'

const PxoOciosidadeTableContainer = ({segment}) => {

    const { selectedDate, selectedHorizonTypeId, setNotFoundTables, updateOciosidadeCalculations } = usePxoPage()

    const [ _pxoOciosidadeTableData,       _setPxoOciosidadeTableData        ] = useState(null)
    const [ _pxoOciosidadeTableMedianData, _setPxoOciosidadeTableMedianData  ] = useState(null)
    
    const [ _isLoading, _setIsLoading ] = useState(true)

    const [ tryFecthAgain, setTryFetchAgain ] = useState(false)    

    const fetchPxoOciosidadeTable = async () => {
        
        _setIsLoading(true)
        
        try {
            
            if (!selectedDate || !selectedHorizonTypeId) return

            const response = await api.get(`/getPxoOciosidadeTable`, {
                params: {
                    selectedDate,
                    pxoHorizonId: selectedHorizonTypeId,
                    segment
                },
                timeout: 30000 
            })

            const { pxoOciosidadeTable, pxoOciosidadeTableMedian } = response.data

            _setPxoOciosidadeTableData(pxoOciosidadeTable)
            _setPxoOciosidadeTableMedianData(pxoOciosidadeTableMedian)
            

        } catch (error) {

            _setPxoOciosidadeTableData(null)
            _setPxoOciosidadeTableMedianData(null)
            setNotFoundTables(true)
            
            if (error.response?.status !== 404 && error.response?.status !== 400) console.log(error)

        }

        _setIsLoading(false)
        
    }


    const updatePxoOciosidadeTableCalculations = async () => {

        _setIsLoading(true)
        
        try {
            
            const response = await api.get(`/updatePxoOciosidadeTableCalculations`, {
                params: {
                    selectedDate,
                    pxoHorizonId: selectedHorizonTypeId,
                    segment
                },
                timeout: 15000 
            })

            const { pxoOciosidadeTable, pxoOciosidadeTableMedian } = response.data

            _setPxoOciosidadeTableData(pxoOciosidadeTable)
            _setPxoOciosidadeTableMedianData(pxoOciosidadeTableMedian)
            

        } catch (error) {
            
            _setPxoOciosidadeTableData(null)
            _setPxoOciosidadeTableMedianData(null)
            setNotFoundTables(true)
            
            if (error.response?.status !== 404 && error.response?.status !== 400) console.log(error)
        }
        _setIsLoading(false)

    }

    useEffect(() => {

        setNotFoundTables(false)
        fetchPxoOciosidadeTable()

    }, [ selectedDate, selectedHorizonTypeId, tryFecthAgain ])


    useEffect(() => {
        
        updatePxoOciosidadeTableCalculations()

    }, [updateOciosidadeCalculations])

    return (

        <div className='text-center w-fit flex flex-col gap-2'>
            
            <h2> Ociosidade Total (h)</h2> 
            
            <div className='flex flex-row gap-4 '>

                {_isLoading ? (
                    <>
                        <PxoLoadingTable
                            rows={segment == "granel" ? 20 : 12}
                            cols={5}
                            headerColor="bg-[#0090D0]"
                        />

                        <PxoLoadingTable
                            rows={segment == "granel" ? 20 : 12}
                            cols={1}
                            headerColor="bg-[#0090D0]"
                        />
                    </>
                ) : _pxoOciosidadeTableData && _pxoOciosidadeTableMedianData ? (
                    <>
                        <PxoOciosidadeTable 
                            allowNames={true}
                            tableData={_pxoOciosidadeTableData}
                        /> 

                        <PxoOciosidadeTable 
                            tableData={_pxoOciosidadeTableMedianData}
                        />  
                    </>
                ) : (
                    <div  className="
                            w-full
                            text-center
                            bg-gray-100
                            h-full
                            p-2.5
                            border
                            border-gray-300
                            rounded
                            cursor-pointer
                            hover:bg-gray-200
                            transition
                        "
                        onClick={() => setTryFetchAgain(!tryFecthAgain)}
                        >
                        Nenhuma informação encontrada.
                        
                        <p className='text-[10px]'>(clique para tentar novamente)</p>                  
                    
                    </div>
                )}

            </div>
            
        </div>
    )
}

export default PxoOciosidadeTableContainer